import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import {
  ApiBaseUrl,
  sendEmailVerificationV2ProfessionalApi,
  verifyEmailVerificationV2ProfessionalApi,
} from "../../Utils/Constants";

export const hitSendEmailVerificationV2Professional = createAsyncThunk(
  "hitSendEmailVerificationV2Professional",
  async (payload) => {
    try {
      const config = {
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
        },
      };
      const url = ApiBaseUrl + sendEmailVerificationV2ProfessionalApi;
      const response = await axios.post(url, payload, config);
      return response.data;
    } catch (error) {
      throw error.response?.data;
    }
  },
);

export const hitVerifyEmailVerificationV2Professional = createAsyncThunk(
  "hitVerifyEmailVerificationV2Professional",
  async (payload) => {
    try {
      const config = {
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
        },
      };
      const url = ApiBaseUrl + verifyEmailVerificationV2ProfessionalApi;
      const response = await axios.post(url, payload, config);
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },
);

const EmailVerificationV2ProfessionalSlice = createSlice({
  name: "emailVerificationV2ProfessionalReducer",
  initialState: {
    isLoading: false,
    data: null,
  },
  reducers: {
    clearEmailVerificationV2ProfessionalData: (state) => {
      state.data = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(hitSendEmailVerificationV2Professional.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(hitSendEmailVerificationV2Professional.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      })
      .addCase(hitSendEmailVerificationV2Professional.rejected, (state) => {
        state.isLoading = false;
      })
      .addCase(hitVerifyEmailVerificationV2Professional.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(hitVerifyEmailVerificationV2Professional.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      })
      .addCase(hitVerifyEmailVerificationV2Professional.rejected, (state) => {
        state.isLoading = false;
      });
  },
});

export const { clearEmailVerificationV2ProfessionalData } =
  EmailVerificationV2ProfessionalSlice.actions;
export default EmailVerificationV2ProfessionalSlice.reducer;
